import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Badge } from "@faire/web/slate/deprecated/Badge";
import { getSpacing } from "@faire/web/slate/spacing";
import { Tooltip } from "@faire/web/slate/Tooltip";
import { TypographyStyles } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React, { useMemo } from "react";
import styled from "styled-components";

import { ReactPortalTooltip } from "@faire/retailer/components/ReactPortalTooltip/ReactPortalTooltip";

import { TopShopTooltipContents } from "./TopShopTooltipContents";

interface IProps {
  content?: string;
  className?: string;
}

export const TopShopTileBadge: React.FC<IProps> = (props) => {
  const { strictLocalize } = useStrictLocalization();
  const { content } = props;

  const badge = useMemo(() => {
    return (
      <StyledBadge
        content={content ?? strictLocalize({ defaultMessage: "Top Shop" })}
        backgroundColor={Core.surface.inverse}
      />
    );
  }, [content, strictLocalize]);

  const { isTabletAndBelow } = useViewport();

  if (isTabletAndBelow) {
    return <div className={props.className}>{badge}</div>;
  }
  return (
    <ReactPortalTooltip
      placement="bottom"
      className={props.className}
      tooltipZIndex={1005}
      tooltip={
        <Tooltip width={308} position="bottom" isOpen icon={<div />}>
          <TopShopTooltipContents />
        </Tooltip>
      }
    >
      {badge}
    </ReactPortalTooltip>
  );
};

const StyledBadge = styled(Badge)`
  ${TypographyStyles({ variant: "labelSansRegular" })};
  font-weight: 500;
  padding: ${getSpacing(3, 7)};
  cursor: pointer;
`;
